module.exports = __webpack_public_path__ + "front/img/404.a57b6f31.png";